if (!customElements.get('image-comparison')) {
  customElements.define(
    'image-comparison',
    class ImageComparison extends HTMLElement {
      constructor() {
        super();

        this.isHorizontal = this.dataset.direction === 'horizontal';
        this.isBewoLayout = this.classList.contains('image-comparison--bewo');
        this.button = this.querySelector('button');

        this.startDrag = this.onStartDrag.bind(this);
        this.drag = this.onDrag.bind(this);
        this.stopDrag = this.onStopDrag.bind(this);

        this.init();

        if (!BewoTheme.config.motionReduced) {
          BewoTheme.Motion.inView(this.querySelector('.image-comparison__animation-trigger'), this.animation.bind(this));
        }
      }

      init() {
        this.buttonIcon =
          this.querySelector('.image-comparison__razor') ||
          this.button.querySelector('.image-comparison__handle') ||
          this.button.querySelector('span');
        this.updateHandleOffset();

        this.querySelectorAll('img').forEach((img) => {
          img.setAttribute('draggable', 'false');
          img.addEventListener('dragstart', (event) => event.preventDefault());
        });

        if (!this.button) return;

        this.button.addEventListener('touchstart', this.startDrag, { passive: false });
        this.button.addEventListener('mousedown', this.startDrag);

        const observeTarget = this.querySelector('.image-comparison__razor-image');
        if (this.isBewoLayout && observeTarget && 'ResizeObserver' in window) {
          this.handleObserver = new ResizeObserver(() => this.updateHandleOffset());
          this.handleObserver.observe(observeTarget);
          this.handleObserver.observe(this.querySelector('.image-comparison__razor'));
        }

        if (this.isBewoLayout) {
          requestAnimationFrame(() => this.syncBewoHitArea());
        }
      }

      disconnectedCallback() {
        this.handleObserver?.disconnect();
      }

      updateHandleOffset() {
        const handleOffsetPercent = Number(this.dataset.handleOffset || 50) / 100;
        const razor = this.querySelector('.image-comparison__razor');
        const width = razor ? razor.offsetWidth : this.buttonIcon ? this.buttonIcon.offsetWidth : 0;
        this.offset = width * handleOffsetPercent || 20;
        this.syncBewoHitArea();
      }

      syncBewoHitArea() {
        if (!this.isBewoLayout || !this.button) return;

        const razor = this.querySelector('.image-comparison__razor');
        if (!razor) return;

        const width = razor.offsetWidth;
        const height = razor.offsetHeight;
        if (!width || !height) return;

        this.button.style.width = `${width}px`;
        this.button.style.height = `${height}px`;
      }

      animation() {
        this.setAttribute('is-visible', '');
        this.classList.add('is-animating');
        setTimeout(() => {
          this.classList.remove('is-animating');
        }, 1e3);
      }

      onStartDrag(e) {
        e.preventDefault();
        document.body.classList.add('body-no-scrollbar');
        this.classList.add('is-dragging');

        if (e.type === 'mousedown') {
          document.addEventListener('mousemove', this.drag);
          document.addEventListener('mouseup', this.stopDrag);
        } else if (e.type === 'touchstart') {
          document.addEventListener('touchmove', this.drag);
          document.addEventListener('touchend', this.stopDrag);
        }
      }

      onStopDrag() {
        document.body.classList.remove('body-no-scrollbar');
        this.classList.remove('is-dragging');

        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.stopDrag);

        document.removeEventListener('touchmove', this.drag);
        document.removeEventListener('touchend', this.stopDrag);
      }

      onDrag(e) {
        const event = (e.touches && e.touches[0]) || e;
        let x, distance;
        if (this.isHorizontal) {
          x = event.pageX - this.offsetLeft;
          distance = this.clientWidth;

          if (BewoTheme.config.isRTL) {
            x = distance - x; // Reverse the x position for RTL
          }
        } else {
          x = event.pageY - this.offsetTop;
          distance = this.clientHeight;
        }

        const max = distance - this.offset;
        const min = this.offset;
        const mouseX = Math.max(min, Math.min(x, max));
        const mousePercent = (mouseX * 100) / distance;
        this.style.setProperty('--percent', mousePercent + '%');
      }
    }
  );
}
